/*
 * Automatically generated by SVGR from assets/icons/*.svg.
 * Do not edit this file or add other components to this directory.
 */
import type { SVGProps } from 'react'
export function TriangleWarningIcon(
  props: SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <mask
        id='triangle-warning_svg__a'
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits='userSpaceOnUse'
        style={{
          maskType: 'alpha',
        }}
      >
        <path fill='#D9D9D9' d='M0 0h24v24H0z' />
      </mask>
      <g mask='url(#triangle-warning_svg__a)'>
        <path
          fill='#F3980F'
          d='M1 21 12 2l11 19zm11-3a.97.97 0 0 0 .713-.288A.97.97 0 0 0 13 17a.97.97 0 0 0-.287-.712A.97.97 0 0 0 12 16a.97.97 0 0 0-.712.288A.97.97 0 0 0 11 17q0 .424.288.712A.97.97 0 0 0 12 18m-1-3h2v-5h-2z'
        />
      </g>
    </svg>
  )
}
